import { Component, OnInit, Input, forwardRef } from '@angular/core';
import { BaseFormComponent } from '../../base-form.component';
import { FormService } from '../../../../services/form/form.service';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  moduleId: module.id,
  selector: 'basic-checkbox',
  templateUrl: './basic-checkbox.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => BasicCheckboxComponent),
      multi: true,
    },
  ],
})
export class BasicCheckboxComponent extends BaseFormComponent implements OnInit, ControlValueAccessor {
  @Input() propertyName: string;
  @Input() displayText: string;
  @Input() isDisabled: boolean = false;
  @Input() formGroupComponent?: boolean;
  @Input() inputClass: string;
  val: boolean;

  onChange;
  onTouched;

  constructor(formService: FormService) {
    super();
    this.formService = formService;
  }

  ngOnInit() {
    super.ngOnInit();
    this.prop = this.propertyName;
    this.componentId = this.prop;
    this.updateFromModel();
  }

  updateFromModel() {
    if (!this.formGroupComponent) {
      this.val = this.getValue(this.prop);
    }
  }

  async trigger() {
    if (!this.formGroupComponent) {
      await this.validateAndSet(this.prop, this.val);
    }
    if (this.onChange && this.onTouched) {
      this.onChange();
      this.onTouched();
      this.value = this.val;
    }
    this.valueChanged.emit();
  }

  set value(value: boolean) {
    this.onChange(value);
    this.onTouched();
  }

  get value(): boolean {
    return this.val;
  }

  registerOnChange(fn): void {
    this.onChange = fn;
  }

  registerOnTouched(fn): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.isDisabled = isDisabled;
  }

  writeValue(value): void {
    if (value) {
      this.val = value;
    }
  }
}
